module.exports = __webpack_public_path__ + "img/ccompany-honor-TPD-20241028.d3652572.jpg";